<template>
<div class="fill" style="overflow: hidden">
    <div class="fill flex main-container" v-if="local">

    <!-- Left Menu -->
    <transition enter-active-class="animated slideInLeft faster" leave-active-class="animated slideOutLeft">
    <div class="left-menu l-menu" v-show="!mobile && !tablet">
        <div class="ta-center l-local-logo" v-if="local.logotype">
            <img :src="Util.img(local.logotype, 'logos')" style="width: 100px; margin: 10px 0px" class="logo">
        </div>
        <div class="ta-center s1 l-local-name">{{local.name}}</div>

        <div class="separator l-separator l-separator-top"></div>
        <div class="flex-fill flex column l-scroll-container" style="overflow-y: auto; overflow-x: hidden; padding-bottom: 20px">

            <div v-if="selectedSuperSection || !superSections.length" class="flex column l-menu-sections" style="margin-bottom: 20px">
                <div v-if="selectedSuperSection" class="s2 ta-left l-title l-title-menu txt-hover" @click="$refs.menuItems.ClickSuperSection({title:'Ver Todos'})"><i class="icon icon-chevron-left" style="transform: scale(0.8); display: inline-block"></i> {{Util.TranslateLanguage('Atrás')}}</div>
                <div class="s2 ta-left l-title l-title-menu" style="margin-top: 20px;">{{selectedSuperSection ? Util.TranslateLanguage(selectedSuperSection, null, false, 'SUPER_SECTION') : Util.TranslateLanguage('Menú')}}</div>
                <div :class="`c2 s2 ta-left txt-hover l-entry l-menu-section-title l-menu-section-${section.title} ${section.unavailable ? 'section-unavailable' : ''}`" style="margin-top: 10px" v-for="section in filteredMenu" :key="section.title" v-show="section.items.length" @click="$refs.menuItems.GoToSection(section)" :title="`Ir a la sección ${section.title} del menu`">{{Util.TranslateLanguage(section.title, null, false, 'SECTION')}}</div>
                
                <div v-if="itemsWithAnticipation.length" class="l-menu-section-reservation section-menu-filter" style="margin-top: 10px">
                    <div class="c2 s2 flex align-center txt-hover" @click="anticipationFilter = !anticipationFilter">
                        <i :class="`icon icon-square${anticipationFilter ? '-check' : ''}`"></i>
                        <span style="margin-left: 5px" :class="anticipationFilter ? '' : ''">{{Util.TranslateLanguage('Productos con reserva')}}  </span>
                    </div>
                </div>
            </div>

            <div class="flex column">
                <div class="s2 ta-left l-title l-title-info">{{Util.TranslateLanguage('Información')}}</div>
                <div class="c2 s2 ta-left txt-hover l-entry " style="margin-top: 10px" @click="Util.Open(`https://maps.google.com/?q=${local.latitude},${local.longitude}`)" :title="`${Util.TranslateLanguage('Abrir ubicación en Google Maps de')} ${local.name}`"><i class="icon icon-map"></i> {{Util.TranslateLanguage('Ubicación')}}</div>
                <div v-if="ecommerceType == 'RESTAURANT'" class="c2 s2 ta-left txt-hover l-entry" style="margin-top: 10px" @click="OpenModalSchedule()" :title="`${Util.TranslateLanguage('Ver horarios disponibles de')} ${local.name}`"><i class="icon icon-clock"></i> {{ Util.TranslateLanguage('Horarios') }}</div>
                <div v-if="local.phone" class="c2 s2 ta-left txt-hover l-entry" style="margin-top: 10px" @click="OpenContact(local.phone)" :title="`${Util.TranslateLanguage('Contactar con')} ${local.name}`"><i class="icon icon-phone"></i> {{Util.TranslateLanguage('Contacto')}}</div>
                <div v-if="local.email" class="c2 s2 ta-left txt-hover l-entry" style="margin-top: 10px" @click="Util.Open(`mailto:${local.email}`)" :title="`${Util.TranslateLanguage('Enviar correo a')} ${local.email}`"><i class="icon icon-mail"></i> {{ local.email }}</div>
                <div v-if="Util.ig(local.instagram)" class="c2 s2 ta-left txt-hover l-entry" style="margin-top: 10px; text-wrap: nowrap;"  @click="Util.Open('https://instagram.com/'+Util.ig(local.instagram))" :title="`${Util.TranslateLanguage('Ver instagram de')} ${local.name}`"><i class="icon icon-instagram"></i> {{Util.ig(local.instagram)}}</div>
                <div v-if="menuLanguages.length" class="c2 s2 ta-left txt-hover l-entry" style="margin-top: 5px;" @click="OpenLanguages(menuLanguages)" :title="`${Util.TranslateLanguage('Seleccionar idioma del Menú')}`"><img style="margin-right: 10px" :src="Util.GetImagePath(selectedLanguage ? selectedLanguage.name : 'Español')">{{selectedLanguage ? selectedLanguage.name : 'Español' }}</div>
            </div>
        </div>
        <div class="separator l-separator l-separator-bottom"></div>
        <a href="https://influyeapp.cl" target="_blank" class="ta-left s3 txt-hover l-powered-by">Powered by Influye</a>
    </div>
    </transition>

    <!-- Center -->
    <div class="center-content ofy bg" ref="panelCenter" id="menu-container">
        <div>

            <!--banner -->
            <div class="flex column relative top-banner c-banner" v-show="(mobile || tablet) || (!mobile && !tablet && banner)" :style="{height: mobile ? '150px' : '200px', 'background-image': banner ? `url('${Util.img(banner, 'banners')}` : '', 'background-size': 'cover', 'background-position': 'center center'}">
                <img class="c-banner-full-image" v-if="banner" :src="Util.img(banner, 'banners')" style="width:100%; display: none">
                <div :class="`fill flex justify-center align-center ${!banner ? 'left-s bg' : ''}`">
                    <img v-if="!banner" :src="Util.img(local.logotype, 'logos')" style="width: 100px; margin-right: 20px" class="logo c-banner-image">
                    <div class="flex column c-banner-content">
                        <div v-show="mobile && !banner" class="ta-left c1 s1 c-banner-local-name" style="margin-bottom: 5px">{{local.name}}</div>
                        <div class="flex absolute" style="left: 10px; right: 10px; bottom: 10px; justify-content: end;">
                             <div v-show="mobile" :class="`flex c1 btn left-s c-banner-actions`">
                                <i v-if="local.address" @click="Util.Open(`https://maps.google.com/?q=${local.latitude},${local.longitude}`)" class="icon icon-map icon-hover" :title="Util.TranslateLanguage('Ubicación')"></i>
                                <i v-if="ecommerceType == 'RESTAURANT'" @click="$refs.modalLocalSchedule.Open()" class="icon icon-clock icon-hover" :title="Util.TranslateLanguage('Horarios')"></i>
                                <i v-if="local.phone" @click="OpenContact(local.phone)" class="icon icon-phone icon-hover" :title="Util.TranslateLanguage('Contactar')"></i>
                                <i v-if="local.email" @click="Util.Open(`mailto:${local.email}`)" class="icon icon-mail icon-hover"></i>
                                <i v-if="Util.ig(local.instagram)" @click="Util.Open('https://instagram.com/'+Util.ig(local.instagram))" class="icon icon-instagram icon-hover" title="Instagram"></i>
                                <img :src="Util.GetImagePath(selectedLanguage ? selectedLanguage.name : 'Español')" :title="Util.TranslateLanguage('Seleccionar idioma del menú')" @click="OpenLanguages(menuLanguages)"  v-if="menuLanguages.length" class="icon icon-hover">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <swiper v-if="carousel && carousel.length" class="swiper c-carousel" :options="{
                loop: true,
                grabCursor: true,
                autoplay: carousel.length > 1,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
            /*
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
            */
            }"
            style="cursor: grab">
                <swiper-slide v-for="entry in carousel" :key="entry.image" class="c-carousel-slide">
                    <img class="c-carousel-image" :src="Util.img(entry.image, 'banners')" alt="" style="width: 100%">
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <!--
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
                -->
            </swiper>

            <!-- @start Instagram Images 
            <div id="panelInstagram">
                <div class="ig-container">
                    <a v-for="ig in instagramImages" :key="ig.image" target="_blank" :href="ig.url" title="Ir al Instagram">
                        <img :src="ig.image" width="200">
                    </a>
                </div>
            </div>
             @end Instagram Images -->
            
            <div v-show="!superSections.length || selectedSuperSection" class="btn relative flex fc c-search-bar" id="search-bar" :style="{overflow: 'none', padding: '0px', margin: mobile ? '5px' : '10px 10px 0px'}">
                <i class="icon icon-search c2 s2 absolute" style="transform: scale(1); margin: 0; left: 12px; top: 16px; font-size: 20px; pointer-events: none"></i>
                <input ref="searchInput" v-model="searchItem" @focus="searchFocused=true" @blur="searchFocused=false" type="text" class="s2 c1" :style="{'flex-shrink': 0, width: '100%', 'max-width': mobile && (!searchItem && !searchFocused) ? '20px' : '', padding: '15px', 'padding-left': '40px'}" :placeholder="Util.TranslateLanguage('Buscar ...')" :title="Util.TranslateLanguage('Buscar items del menú')">
                <i v-show="(searchItem || searchFocused)" class="icon icon-x absolute btn-hover c2" style="right: 10px; font-size: 25px; top: 14px; transform: scale(1);" @click="searchItem = ''"></i>
                <div ref="searchSections" class="flex align-center flex-fill c-menu-section-container" style="flex-wrap: nowrap; overflow: auto;" v-show="(mobile || tablet)" v-if="!searchItem && !searchFocused">
                    <div v-if="selectedSuperSection" @click="$refs.menuItems.ClickSuperSection({title:'Ver Todos'})" class="unshrink s2 flex align-center c-menu-section-entry c-menu-section-entry-reservation s2 txt-hover-2 section-menu-filter">
                        <i class="icon icon-chevron-left mr10" style="transform: scale(0.8) translateX(-5px)"></i> {{Util.TranslateLanguage('Atrás')}}
                    </div>
                    <div :class="` s2 txt-hover-2 c-menu-section-entry c-menu-section-entry-${section.title.replace(/ /g, '')} ${section.unavailable ? 'section-unavailable' : ''}`" style="flex-shrink: 0" v-for="section in filteredMenu" :key="section.title" v-show="section.items.length" @click="$refs.menuItems.GoToSection(section)" :title="`Ir a la sección ${section.title} del menú`"><div>{{Util.TranslateLanguage(section.title, null, false, 'SECTION')}}</div></div>
                    <div v-if="itemsWithAnticipation.length" class="unshrink flex align-center c-menu-section-entry c-menu-section-entry-reservation s2 txt-hover-2 section-menu-filter">
                        <div class="flex align-center" @click="anticipationFilter = !anticipationFilter">
                            <i :class="`icon icon-square${anticipationFilter ? '-check' : ''}`" style="transform: scale(1); font-size: 15px"></i>
                            <span style="margin-left: 8px" :class="anticipationFilter ? '' : ''">{{Util.TranslateLanguage('Productos con reserva')}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <menu-items ref="menuItems"
            :menu="filteredMenu"
            :search="searchItem" 
            :analytics="$refs.analytics" 
            :canOpenItems="false"
            :canAddItems="false"
            :itemPriceDisplay="itemPriceDisplay"
            :itemImageSize="itemImageSize"
            :behaviour="menuDisplay"
            @ClearSearch="searchItem=''"
            @OnClickItem="itemDetails ? OpenModalItem($event) : null"
            :superSections="superSections"
            :selectedSuperSection="selectedSuperSection"
            @OnClickSuperSection="selectedSuperSection = $event"
            ></menu-items>

            <div v-if="mobile" class="ta-center" style="padding: 10px 0px 20px 0px">
                <a href="https://influyeapp.cl" target="_blank">Powered by Influye</a>
            </div>

        </div>
    </div>

    <loading-screen :loading="loading"></loading-screen>
    <analytics-controller ref="analytics" :dictItems="dictItems" :categories="categories"></analytics-controller>

    </div>

    <modal v-model="modalItem" 
        :title="modalItem ? Util.TranslateLanguage(modalItem.title, null, false, 'ITEM', {id:modalItem.id}) : null" 
        :desktopWidth="null" 
        :desktopHeight="null" 
        class="modal-item">
        <div :class="`ofy flex-fill flex ${mobile ? 'column' : ''}`" v-if="modalItem">
            <div v-if="modalItem.image" v-show="!mobile && itemImageSize == 'DEFAULT'" class="it-item-image-default" :style="{'width': '40%', 'min-width': '40%', height: mobile ? '200px' : '100%', 'background-image': `url('${Util.img(modalItem.image, 'products')}')`, 'background-size': 'cover', 'background-position': 'center'}"></div>
            <div class="ofy flex-fill flex column relative it-item-container" style="padding: 20px; overflow-x: hidden">

                <img v-if="modalItem.image" v-show="mobile && itemImageSize == 'DEFAULT'" :src="Util.img(modalItem.image, 'products')" class="it-image it-image-default" style="width: calc(100% + 40px); margin: -20px 0px 20px -20px">
                <div v-if="Util.TranslateLanguage(modalItem.description, null, true, 'ITEM', {id:modalItem.id, description : modalItem.description}) || itemImageSize == 'SMALL'" class="it-info break-spaces">
                    <div class="flex it-item-info">
                        <img v-if="modalItem.image && itemImageSize == 'SMALL'" :src="Util.img(modalItem.image, 'products')" class="logo it-image it-image-small" style="margin-right: 10px; width: 50px; height: 50px">
                        <div v-if="Util.TranslateLanguage(modalItem.description, null, true, 'ITEM', {id: modalItem.id, description : modalItem.description})" class="c1 s3 it-item-description break-spaces" v-html="Util.StyleText(Util.TranslateLanguage(modalItem.description, null, true, 'ITEM', {id:modalItem.id, description : modalItem.description}))"></div>
                    </div>
                    <div class="separator"></div>
                </div>
                
                <div v-for="(item, indexItem) in (modalItem.type == 0 ? [modalItem] : modalItem.products)" class="flex column it-groups-container" style="gap: 20px" :key="`item-${indexItem}`">

                    <div class="flex column it-subitem" v-if="modalItem.type == 1">
                        <div class="separator" v-if="indexItem > 0"></div>
                        <div class="flex">
                            <img :src="Util.img(item.image, 'products')" class="logo it-image it-subitem-image" style="margin-right: 10px; width: 50px; height: 50px">
                            
                            <div class="flex column it-subitem-info">
                                <div class="s1 c1 it-subitem-title">{{Util.TranslateLanguage(item.title, null, false, 'ITEM', {id:item.id})}}</div>
                                <div v-if="Util.TranslateLanguage(item.title, null, true, 'ITEM', {id:item.id, description: item.description})" class="c2 s3 it-subitem-description break-spaces" v-html="Util.StyleText(Util.TranslateLanguage(item.title, null, true, 'ITEM', {id:item.id, description: item.description}))"></div>
                            </div>
                        </div>
                    </div>

                    <div class="flex column it-group" v-for="(group, indexGroup) in item.modifiers" :key="`group-${indexGroup}`">
                        <div class="s1 c1 it-group-title" style="margin-bottom: 10px">{{Util.TranslateLanguage(group.title, null, false, 'GROUP', {id:item.id, group:group.title})}}</div>

                        <div class="flex column mp-modifiers-container" style="gap: 5px">
                            <div :class="`flex mp-modifier ${modifier.unavailable ? 'modifier-unavailable' : ''}`" v-for="(modifier, indexModifier) in group.modifiers" :key="`mod-${indexModifier}`">
                                <div class="flex-fill flex column mp-modifier-info">
                                    <div class="s2 c1 mp-modifier-title">{{Util.TranslateLanguage(modifier.title, null, false, 'MODIFIER', {id:item.id, group: group.title, modifier: modifier.title})}}</div>
                                    <div class="s3 c2 mp-modifier-description break-spaces" v-html="Util.StyleText(Util.TranslateLanguage(modifier.title, null, true, 'MODIFIER', {id:item.id, group: group.title, modifier: modifier.title, description : modifier.description}))"></div>
                                </div>
                                <div class="s2 c1 mp-modifier-price">{{Util.Price(modifier.price)}}</div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        
    </modal>

</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import "swiper/css/swiper.min.css";
import LoadingScreen from './common/LoadingScreen.vue';
import ModalSchedule from './common/ModalSchedule.vue';
import ModalMap from './common/ModalMap.vue';
import AnalyticsController from './common/AnalyticsController.vue';
import ModalCoupon from './common/ModalCoupon.vue';
import ModalTip from './common/ModalTip.vue';
import LeftMenu from './common/LeftMenu.vue';
import MenuItems from './common/MenuItems.vue';

var moment = require('moment');
export default {
    components: {LoadingScreen, Swiper, SwiperSlide, ModalSchedule, ModalMap,
        AnalyticsController, ModalCoupon, ModalTip,
        LeftMenu, MenuItems
    },
    data() {
        return {
			//@data loading <Boolean> indicador si estan cargando los datos del ecommerce
            loading: true,
            local: null,
            menu: null,
            searchItem: '',
            searchFocused: false,
            dictItems: {},
            carousel: null,
            categories: {},
            itemPriceDisplay: 'ITEM_PRICE',
            anticipationFilter: false,
            itemImageSize: 'DEFAULT',
            modalItem: null,
            menuDisplay: 'ALL',
            itemDetails: true,
            superSections : [],
            menuLanguages : null,
			settingsShowSuperSection : true,
            selectedSuperSection: '',
        }
    },
    mounted() {
        var momentES = moment();
        momentES.locale('es');
        if(typeof data == 'undefined')
        {
            //load data from query
            axios.get(`data`).then(res => {
                this.InitialSetup(res.data);    
            }).catch(err => {
                this.loading = 'ERROR';
            });
        }
        else
        {
            //load data embeded on page
            this.InitialSetup(data.data);
        }

        window.onpopstate = (event) => {
            if (!event.state || event.state.page === "home") {
                this.selectedSuperSection = '';
            }
        };

    },
    methods: {
        InitialSetup(data)
        {
            this.timestamp = data.timestamp;
            this.today = moment.unix(this.timestamp).format('dddd').toLowerCase();

            this.local = data.local;
            this.menu = data.menu;
            this.instagramImages = data.ig_images;
            this.schedules = data.open_at;
            this.delay = data.delay;
            this.format_hour = data.format_hour;
            this.Util.setFormatHour(this.format_hour);
            this.format_range = data.format_range;
            this.defaultSale = data.default_sale;
            this.orderOptions = data.order_options;
            this.paymentMethods = data.payment_methods;

            this.minimun = data.delivery_minimun;
            this.recommendProductsConfig = data.recommend_products_active;
            this.banner = data.banner;
            this.ecommerceType = data.ecommerce_type;
            this.shipmentType = data.shipment_type;
            this.canSchedule = this.ecommerceType == 'RESTAURANT' ? data.accepts_scheduled : this.shipmentType !== 'AUTO';
            document.body.classList.add(this.ecommerceType);
            this.moduleCoupons = data.coupons;
            this.disabledUntil = data.disabled_until;
            this.carousel = data.carousel;
            this.topItems = data.popular;
            this.customization = data.customization;
            this.tipsEnabled = data.tips;
            this.defaultTip = data.default_tip;
            this.menuLanguages = data.languages;
            this.settingsShowSuperSection = !!data.show_supersection;
            if(data.categories) this.categories = data.categories;
            this.timePatch = data.time_patch;
            if(!isNaN(data.min_scheduled_time_today)) this.scheduledMinTime = data.min_scheduled_time_today;
            if(data.item_price_display) this.itemPriceDisplay = data.item_price_display;
            if(data.menu_display) this.menuDisplay = data.menu_display;
            if('item_details' in data) this.itemDetails = data.item_details;

            if(this.orderOptions.delivery && this.orderOptions.takeaway){
                this.type = this.defaultSale == 'DELIVERY'? 'DELIVERY' : 'TAKEAWAY';
            }else{
                if(this.orderOptions.delivery) this.type = 'DELIVERY';
                else if(this.orderOptions.takeaway) this.type = 'TAKEAWAY';
            }


            let settingsShowSuperSection = !!data.show_supersection;
            var tmpSuperSections = {};
            this.menu.forEach(section => {
                
                if(settingsShowSuperSection)
                {
                    if(section.super_section){
                        tmpSuperSections[section.super_section] = {title : section.super_section}
                    } 
                }

                section.items.forEach(item => {
                    if(section.title != 'Productos con anticipación'){
                        item.section = section.title;
                        this.dictItems[item.id] = item;
                        this.dictItems[item.id].section_hide_delivery = section.hide_delivery;
                        this.dictItems[item.id].section_hide_takeaway = section.hide_takeaway;
                    }
                });
            });       
            this.superSections = Object.values(tmpSuperSections);
            if(this.superSections.length < 2) {
                this.settingsShowSuperSection = false;
                this.superSections = [];
            }
            this.Util.ApplyCustomization(data.customization);
            if(data.customization && data.customization.item_image_size) this.itemImageSize = data.customization.item_image_size;

            this.$nextTick(() => {
                //Google Analytics
                this.$refs.analytics.SetupGoogleAnalytics(data.google_analytics);

                //var facebookPixelID = '539373001231229';
                this.$refs.analytics.SetupFacebookPixel(data.facebook_pixel, data.facebook_access_token);
                this.loading = false;

                const currentPath = window.location.pathname;            
                const itemTitle = decodeURIComponent(currentPath.substring(1));

                if(itemTitle){
                    let foundItem = null;
                    let foundSuperSection = null;
                    for (const section of Util.Copy(this.filteredMenu)) {
                        foundItem = section.items.find(item => item.title === itemTitle.trim());                    
                        if(foundItem && settingsShowSuperSection) foundSuperSection = {title : section.super_section};
                        if(foundItem) break;
                    }

                    //Esto es para cuando se va a una seccion directamente desde la URL
                    if(!foundItem && settingsShowSuperSection) {
                        foundSuperSection = this.superSections.find(section => section.title.trim() === itemTitle.trim());
                    }
                    
                    this.$nextTick(() => {   
                        if(this.$refs.menuItems){
                            if(foundSuperSection) 
                            {
                                let queryParams = window.location.search;
                                history.replaceState(null, '', `${window.location.origin}${queryParams}`);  
                                this.$refs.menuItems.ClickSuperSection(foundSuperSection)
                            }
                            if(foundItem && !foundItem.unavailable) this.OpenModalItem(foundItem);
                        }
                    });
                }       

            })
            let existLang = localStorage.getItem('language');
            if(existLang) this.LoadLanguageFromLocalStorage(existLang);
            
        },
        OpenModalItem(item) {
            const queryParams = window.location.search;
            const newUrl = `${window.location.origin}/${encodeURIComponent(item.title)}%20${queryParams}`;
            setTimeout(() => {
                history.replaceState(history.state, item.title, newUrl);
            }, 100);

            this.modalItem = item;
            
            this.$refs.analytics.Trigger('view_item', item);
        },
    },
    computed: {
        filteredMenu(){
            if(!this.menu) return;

            let ret = Util.Copy(this.menu);

            if(this.selectedSuperSection) {
                // Realiza el filtro segun la sesleccion de la super seccion
                let tmp = [];
                ret.forEach(section => {
                    if(section.super_section == this.selectedSuperSection) tmp.push(section);
                });
                ret = tmp;
            }


            if(this.anticipationFilter){
                ret = ret.map(section => ({
                    ...section,
                    items: section.items.filter(item => item.anticipation && item.anticipation_time != null)
                }));
            }
            return ret;
        },
        //para ver si existen items con reserva y mostrar/ocultar el filtro
        itemsWithAnticipation() {
            let ret = [];
            for(let key in this.dictItems)
            {
                if(this.dictItems[key].anticipation && this.dictItems[key].anticipation_time > 0) 
                    ret.push(this.dictItems[key]);
            }
            return ret;
        },
    },
}
</script>

<style lang="scss">

</style>